export const Options = {
    BecomingAwareThrough: [
        { text:"Bewerbermesse",value:"Bewerbermesse" },
        { text:"Homepage DVAG",value:"Homepage DVAG" },
        { text:"Indeed",value:"Indeed" },
        { text:"Kununu / XING",value:"Kununu / XING" },
        { text:"Linkedin",value:"Linkedin" },
        { text:"Mitarbeiterempfehlung",value:"Mitarbeiterempfehlung" },
        { text:"Personalberatung",value:"Personalberatung" },
        { text:"Stepstone",value:"Stepstone" },
        { text:"Social Media (Facebook, Instagram, TikTok)",value:"Social Media (Facebook, Instagram, TikTok)" },
        { text:"Sonstige",value:"Sonstige" },
    ]
}
